import PropTypes from "prop-types";
import { Line } from "react-chartjs-2";
import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

function GrowthLineChart({ chart }) {
  const maxValue = Math.max(...chart.datasets.flatMap((dataset) => dataset.data || []), 10);
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        position: "top",
        align: "center",
        labels: {
          usePointStyle: true,
          boxWidth: 8,
          boxHeight: 8,
          color: "#8b94a7",
          font: {
            size: 12,
            family: "Inter, Segoe UI, sans-serif",
            weight: 500,
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#9ea7ba",
          font: {
            size: 11,
            family: "Inter, Segoe UI, sans-serif",
          },
          maxTicksLimit: 3,
          callback: function (value, index) {
            const label = this.getLabelForValue(value);
            const totalLabels = this.chart.data.labels.length;
            const date = new Date(label);

            // 7 days → show weekday name (Mon, Tue...)
            if (totalLabels <= 7) {
              return date.toLocaleDateString("en-US", { weekday: "short" });
            }

            // 30 days → show DD/MM
            if (totalLabels <= 30) {
              return date.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
              });
            }

            // 90 days or 1 year → show month label only ONCE (on the 1st of the month)
            if (totalLabels <= 365) {
              if (date.getDate() === 1) {
                return date.toLocaleDateString("en-US", { month: "short" });
              }
              return null; // hide all other ticks
            }

            return null;
          },
          autoSkip: false, // keep false so our null-returns control visibility
          maxRotation: 0,
          minRotation: 0,
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        suggestedMax: maxValue + 2,
        ticks: {
          color: "#9ea7ba",
          font: {
            size: 11,
            family: "Inter, Segoe UI, sans-serif",
          },
        },
        grid: {
          color: "#edf1f6",
          drawBorder: false,
        },
      },
    },
  };

  return (
    <div className="sd-growth-chart">
      <Line data={chart} options={options} />
    </div>
  );
}

GrowthLineChart.propTypes = {
  chart: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    datasets: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
};

export default GrowthLineChart;
